import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import React, { useRef, useState } from 'react';
import frameImg from '../assets/img/add_image_bg.png';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { getText, getPath } from '../common/utils/helpers';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as IconClose } from '../assets/svg/icon_close.svg';
import ImageSlider from './ImageSlider';
import ImageGallery from 'react-image-gallery';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { ReactComponent as CloseIcon } from '../assets/svg/icon_close.svg';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

interface IProps {
  sliderData?: any;
  onImageChange?: (imageNr) => void;
  onClose?: (event: React.SyntheticEvent) => void;
  currentImageNr?: number;
}

const urlPrefix = getPath();

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      imageStoryContainerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      imageStoryWrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
      storyContainerStyle: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        boxSizing: 'border-box',
        // padding: '0 40px',
        fontFamily: FONTS.roboto,
      },
      headingContainerStyle: {
        position: 'relative',
        width: '100%',
        minHeight: '80px',
        backgroundColor: '#e0d0a4',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '20px',
      },
      headingStyle: {
        position: 'relative',
        width: '100%',
        height: 'auto',
        fontSize: '22px',
        lineHeight: '22px',
        alignSelf: 'center',
      },
      dateAndPlaceStyle: {
        textAlign: 'right',
        fontSize: '16px',
        lineHeight: '20px',
        marginLeft: 'auto',
        width: '100%',
        alignSelf: 'center',
      },
      dataContainerStyle: {
        position: 'relative',
        marginTop: '30px',
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
      textStyle: {
        fontSize: '18px',
        lineHeight: '24px',
        textAlign: 'justify',
        marginRight: '14px',
        maxWidth: '350px',
      },
      imageWrapperStyle: {
        position: 'relative',
        // minWidth: '60%',
        width: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '-10px',
        marginRight: '-10px',
        marginLeft: 'auto',
      },
      imageSubWrapperStyle: {
        position: 'relative',
        width: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      },
      frameStyle: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      photoStyle: {
        position: 'absolute',
        width: '90%',
        height: '86%',
        // objectFit: 'contain',
      },
      imageDescrContainerStyle: {
        position: 'relative',
        marginTop: '10px',
        width: 'calc(100% - 16px)',
        height: 'auto',
        backgroundColor: '#e0d0a4',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 20px',
      },
      imageDescrStyle: {
        textAlign: 'left',
        fontSize: '16px',
        lineHeight: '20px',
      },
      imageStyle: {
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        objectFit: 'contain',
      },
      iconCloseStyle: {
        position: 'absolute',
        width: '40px',
        height: '40px',
        top: '-34px',
        right: '-40px',
        fill: COLORS.appBrown,
        border: `1px solid ${COLORS.appBrown}`,
        borderRadius: '50%',
        padding: '4px',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: '0.7',
            transition: '0.5s ease',
          },
        },
      },
      imageContainerStyle: {
        position: 'relative',
        width: '100%',
        height: '140px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      dialogContainerStyle: {
        '& > div > div': {
          width: '100%',
          background: COLORS.white,
        },
      },
      closeButtonStyle: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        fill: COLORS.textGray,
        width: '40px',
        height: '40px',
        pointerEvents: 'auto',
        zIndex: 1000,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContentStyle: {
        margin: '0 16px',
        color: COLORS.appBrown,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        overflow: 'hidden',
      },
      '@global': {
        '.image-gallery-content': {
          height: '100vh',
        },
        '.image-gallery-thumbnail': {
          width: '70px !important',
        },
        '.image-gallery-slide-wrapper': {
          height: 'calc(100vh - 80px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      [`@media (max-width: 800px)`]: {
        dataContainerStyle: {
          flexDirection: 'column-reverse',
          marginTop: '20px',
        },
        imageWrapperStyle: {
          margin: '0 0 10px 0',
        },
        textStyle: {
          margin: 0,
          maxWidth: '100%',
        },
        imageDescrContainerStyle: {
          width: '100%',
        },
      },
      [`@media (max-width: 600px)`]: {
        headingContainerStyle: {
          flexDirection: 'column',
          padding: '10px 16px',
        },
        dataContainerStyle: {
          marginTop: '10px',
        },
      },
    })
);

const ImageStory = ({
  onClose,
  sliderData,
  onImageChange,
  currentImageNr = 1,
}: IProps): JSX.Element => {
  const classes = useStyles();
  const lng = useSelector((state) => state.app.lng);
  const parentRef = useRef<any>();
  const childRef = useRef<any>();

  const [isGalleryVisible, setGalleryVisible] = useState(false);

  if (!sliderData) {
    return null;
  }

  const data = sliderData[currentImageNr - 1];

  const { text, image_text, time, place, period, header } = data?.content;
  const dateAndPlace = `${time}<br />${place}`;

  const imgUrl: string = `${urlPrefix}${data.images?.[0].url}`;

  const changeImage = (photoNumber = 1) => {
    if (onImageChange) {
      onImageChange(photoNumber);
    }
  };

  const getImageItem = (image) => {
    const { content: imageContent, images } = image;
    const description: string =
      (imageContent && getText(imageContent, 'text', lng)) || '';
    const original: string = `${urlPrefix}${images[0].url}`;
    const thumbnail: string = `${urlPrefix}${images[0].thumb}`;

    const item = {
      original,
      thumbnail,
      description,
    };

    return item;
  };

  const getGalleryData = () => {
    const items: any[] = [];

    for (const image of sliderData) {
      // if (image?.cover) {
      //   continue;
      // }

      const item = getImageItem(image);
      items.push(item);
    }

    return items;
  };

  const galleryData = getGalleryData();
  const hasMultiple: boolean = galleryData.length > 1;

  const openGallery = () => {
    setGalleryVisible(true);
  };

  const closeGallery = () => {
    setGalleryVisible(false);
  };

  const onSlide = (e) => {
    onImageChange(e + 1);
  };

  const getGallery = () => {
    return (
      <Dialog
        fullScreen={true}
        open={true}
        onClose={onClose}
        className={classes.dialogContainerStyle}
      >
        <CloseIcon
          className={classes.closeButtonStyle}
          onClick={closeGallery}
        />
        <MuiDialogContent className={classes.dialogContentStyle}>
          <ImageGallery
            items={galleryData}
            startIndex={currentImageNr - 1}
            showThumbnails={hasMultiple}
            showFullscreenButton={false}
            showPlayButton={hasMultiple}
            useTranslate3D={true}
            onClick={closeGallery}
            onSlide={onSlide}
            thumbnailPosition={'top'}
            additionalClass={classes.galleryStyle}
          />
        </MuiDialogContent>
      </Dialog>
    );
  };

  return (
    <div className={classes.imageStoryContainerStyle}>
      <div className={classes.imageStoryWrapperStyle}>
        <div className={classes.storyContainerStyle}>
          <div className={classes.headingContainerStyle}>
            <div
              className={classes.headingStyle}
              dangerouslySetInnerHTML={{ __html: header }}
            />
            <div
              className={classes.dateAndPlaceStyle}
              dangerouslySetInnerHTML={{ __html: dateAndPlace }}
            />
          </div>

          <div className={classes.dataContainerStyle}>
            <div
              className={classes.textStyle}
              dangerouslySetInnerHTML={{ __html: text }}
            />
            <div className={classes.imageWrapperStyle}>
              <div className={classes.imageSubWrapperStyle}>
                <img className={classes.frameStyle} src={frameImg} alt="" />
                <div className={classes.photoStyle}>
                  <img
                    className={classes.imageStyle}
                    src={imgUrl}
                    alt=""
                    onClick={openGallery}
                  />
                </div>
              </div>
              <div className={classes.imageDescrContainerStyle}>
                <div
                  className={classes.imageDescrStyle}
                  dangerouslySetInnerHTML={{ __html: image_text }}
                />
              </div>
            </div>
          </div>

          {sliderData && sliderData.length > 1 && (
            <div className={classes.imageContainerStyle} ref={parentRef}>
              <ImageSlider
                data={galleryData}
                openImage={changeImage}
                ref={childRef}
              />
            </div>
          )}
        </div>
      </div>
      {Boolean(onClose) && (
        <IconClose className={classes.iconCloseStyle} onClick={onClose} />
      )}
      {isGalleryVisible && getGallery()}
    </div>
  );
};

export default ImageStory;
